import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  getDefaultFiltersFromHistory,
  patchUrlFilters,
} from '../helpers';

const useUrlSyncedTableState = ({ enabled, initialOrderBy }) => {
  const history = useHistory();
  const {
    defaultFilters,
    defaultGlobalFilter,
    defaultOrderBy,
  } = getDefaultFiltersFromHistory(history, initialOrderBy);
  const urlFilters = enabled ? defaultFilters : {};
  const [globalFilter, setGlobalFilter] = useState(
    enabled ? defaultGlobalFilter : '',
  );
  const [orderBy, setOrderBy] = useState(
    enabled ? (defaultOrderBy ?? '') : (initialOrderBy ?? ''),
  );

  useEffect(() => {
    if (!enabled) return;
    setGlobalFilter(defaultGlobalFilter);
  }, [history.location.search, defaultGlobalFilter, enabled]);

  useEffect(() => {
    if (!enabled) return;
    setOrderBy(defaultOrderBy ?? '');
  }, [history.location.search, defaultOrderBy, enabled]);

  useEffect(() => {
    if (!enabled) return;
    patchUrlFilters(history, { globalFilter });
  }, [globalFilter, enabled, history]);

  useEffect(() => {
    if (!enabled) return;
    patchUrlFilters(history, { orderBy });
  }, [orderBy, enabled, history]);

  return {
    globalFilter,
    setGlobalFilter,
    orderBy,
    setOrderBy,
    urlFilters,
  };
};

export default useUrlSyncedTableState;
